export const CHART_LEGEND_LABELS = [
  {
    i18nKey: "alpian",
    className: "bg-primary-content",
  },
  {
    i18nKey: "morningstarMarkets",
    className: "bg-purple-dark",
  },
  {
    i18nKey: "morningstarCore",
    className: "bg-blue-dark",
  },
];
